/**
 * Marketplace hero banner kontraktlari — EGASI POS'dan boshqaradi.
 *
 * Banner = bosh sahifa karusel rasmi (/uploads/banners/...). Ixtiyoriy havola:
 * NONE (havolasiz), CATALOG (katalogga), CATEGORY (kategoriya nomiga → linkValue).
 * Rasm UPLOAD orqali (multipart) — bu yerda faqat metadata schema'lari.
 */
import { z } from 'zod';
export const bannerLinkTypeSchema = z.enum(['NONE', 'CATALOG', 'CATEGORY']);
/** Banner havola metadatasi (create multipart body + update'da qayta ishlatiladi). */
export const bannerLinkSchema = z
    .object({
    linkType: bannerLinkTypeSchema.default('NONE'),
    linkValue: z.string().trim().max(160).optional(),
})
    .refine((d) => d.linkType !== 'CATEGORY' || (d.linkValue !== undefined && d.linkValue !== ''), {
    message: 'CATEGORY havolasi uchun kategoriya nomi (linkValue) kerak',
    path: ['linkValue'],
});
/** Banner yangilash (admin) — barcha maydonlar ixtiyoriy (qisman yangilash). */
export const updateBannerSchema = z
    .object({
    linkType: bannerLinkTypeSchema.optional(),
    linkValue: z.string().trim().max(160).nullable().optional(),
    sortOrder: z.number().int().min(0).max(10_000).optional(),
    isActive: z.boolean().optional(),
})
    .refine((d) => d.linkType !== 'CATEGORY' || (d.linkValue !== undefined && d.linkValue !== null && d.linkValue !== ''), { message: 'CATEGORY havolasi uchun kategoriya nomi kerak', path: ['linkValue'] });
/** Bannerlarni qayta tartiblash — id'lar yangi tartibda. */
export const reorderBannersSchema = z.object({
    ids: z.array(z.string().uuid()).min(1).max(50),
});
//# sourceMappingURL=marketplace-banner.schema.js.map